import React from 'react';
import { HeadlineTitle } from '../../components/Title';
import { SectionLayout } from '../../components/Layouts';
import { Row, Col } from '../../components/Grid';

import * as T from '../../components/Typography';
import * as S from './style';

import composeStyle from '../../utils/composeStyle';
import TickPoint from '../../components/TickPoint';

const Title = composeStyle(S.StyledH3, 'H4', 'Body16');

// cms functionality: headline text, subtitle, blurbs

const JoinTempoSection = ({ title, description, data, JoinSecSubtitle }) => {
  return (
    <SectionLayout id="join-tempo">
      <Row>
        <Col w={[4, 6, 8]}>
          <HeadlineTitle>{title}</HeadlineTitle>
        </Col>

        <Col w={[4, 6, 8]}>
          <T.P16 color="black3" mt={4} mtT={3} mtM={2} as="pre">
            {description}
          </T.P16>
        </Col>
        <Col w={[4, 6, 8]}>
          <Title mt={5} mtM={0}>
            {JoinSecSubtitle}
          </Title>
        </Col>
      </Row>
      <Row mt={2}>
        {data.map(({ blurb: _text }) => {
          return (
            <Col w={[4, 3, 4]} mt={2}>
              <TickPoint text={_text} />
            </Col>
          );
        })}
      </Row>
    </SectionLayout>
  );
};

export default JoinTempoSection;
